/**
 * Wraps every ® and ™ found in page text with <sup class="tm-mark"> so the
 * styling is identical site-wide (see trademark-superscript.css).
 * Covers merchant-editable content (settings, metafields, product/collection
 * titles) and content injected later (drawers, predictive search, AJAX).
 */
(function () {
  var MARKS = /[®™]/;
  var MARKS_G = /([®™])/g;
  var SKIP = 'SCRIPT,STYLE,NOSCRIPT,TEXTAREA,INPUT,SELECT,OPTION,TITLE,SUP,SUB,CODE,PRE,SVG,TEMPLATE,IFRAME';

  function shouldSkip(node) {
    var el = node.parentElement;
    if (!el) return true;
    if (el.isContentEditable) return true;
    return !!el.closest(SKIP.toLowerCase() + ',.tm-mark,.superscripted,[data-no-tm]');
  }

  function wrap(textNode) {
    var parts = textNode.nodeValue.split(MARKS_G);
    var frag = document.createDocumentFragment();
    parts.forEach(function (part) {
      if (part === '®' || part === '™') {
        var sup = document.createElement('sup');
        sup.className = 'tm-mark';
        sup.textContent = part;
        frag.appendChild(sup);
      } else if (part) {
        frag.appendChild(document.createTextNode(part));
      }
    });
    textNode.parentNode.replaceChild(frag, textNode);
  }

  function process(root) {
    if (!root || root.nodeType === 8) return;
    if (root.nodeType === 3) {
      if (MARKS.test(root.nodeValue) && !shouldSkip(root)) wrap(root);
      return;
    }
    if (root.nodeType !== 1) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        return MARKS.test(n.nodeValue) && !shouldSkip(n) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(wrap);
  }

  var pending = [];
  var scheduled = false;
  function flush() {
    scheduled = false;
    var batch = pending;
    pending = [];
    observer.disconnect();
    batch.forEach(function (n) {
      if (n.isConnected) process(n);
    });
    observe();
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type === 'characterData') pending.push(m.target);
      else m.addedNodes.forEach(function (n) { pending.push(n); });
    });
    if (pending.length && !scheduled) {
      scheduled = true;
      requestAnimationFrame(flush);
    }
  });

  function observe() {
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    process(document.body);
    observe();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
